'use client';

import { useTranslations } from 'next-intl';
import type { CreditTransaction } from '@/lib/hooks/useCredits';

/** Render the server's typed settlement projection, never infer status from prose. */
export function CreditTransactionSummary({ transaction, locale }: {
  transaction: CreditTransaction;
  locale: string;
}) {
  const t = useTranslations('nav');
  const title = transaction.description_key
    ? t(`creditTransactionDescriptions.${transaction.description_key}`)
    : transaction.description || transaction.model_name || t(`usageRecordTypes.${transaction.transaction_type}`);
  const meta = transaction.description_key !== 'canvas_agent_text' && transaction.model_name
    ? transaction.model_name
    : t(`usageRecordTypes.${transaction.transaction_type}`);
  const date = new Date(transaction.created_at);
  const formattedDate = Number.isNaN(date.getTime()) ? transaction.created_at
    : new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date);
  return (
    <div className="min-w-0">
      <p className="truncate text-[13px] font-semibold leading-5 text-[#111827]">
        {title || t('usageHistoryUnknownDescription')}
      </p>
      <div className="mt-1 flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1 text-[11px] leading-4 text-[#8A93A2]">
        <span>{meta}</span>
        <span aria-hidden>·</span>
        <span>{formattedDate}</span>
      </div>
      {transaction.settlement_detail ? (
        <p className="mt-1 text-[11px] leading-4 text-[#6B7280]">
          {t('creditTransactionSettlementDetail', transaction.settlement_detail)}
        </p>
      ) : null}
    </div>
  );
}
